import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./Components/Common/Header/Header.jsx";
import Footer from "./Components/Common/Footer/Footer.jsx";
import HomePage from "./Components/Pages/Home.jsx";
import PrivacyPolicy from "./Components/Pages/PrivacyPolicy.jsx";
import TermsAndConditions from "./Components/Pages/TermsAndConditions.jsx";
import ComingSoon from "./Components/Pages/ComingSoon.jsx";
import NotFound from "./Components/Pages/NotFound.jsx";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/products" element={<HomePage />} />
        <Route path="/features" element={<HomePage />} />
        <Route path="/demo" element={<HomePage />} />
        <Route path="/future" element={<HomePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App; 